import { useWorkqueueEmployees } from 'common/utils/Workqueue/hooks/useWorkqueueEmployees';
import { useCurrentEmployeeId } from 'common/contexts/CurrentEmployeeContext';

export const REQUEST_UNASSIGNED = 'unassigned';

export const useAssigneeOptions = (role = '', enabled = true, showAssignedToUserFilterLabel = false) => {
  const currentEmployeeId = useCurrentEmployeeId();
  const employees = useWorkqueueEmployees(role, enabled);

  const result = [];

  result.push({
    label: 'Unassigned',
    value: REQUEST_UNASSIGNED,
  });

  employees.forEach((employee) => {
    if (employee.id === currentEmployeeId) {
      const label = showAssignedToUserFilterLabel ? 'Assigned to me' : `${employee.full_name} (Assign to me)`;
      result.unshift({
        label,
        value: employee.id,
      });
    } else {
      result.push({
        label: employee?.full_name,
        value: employee?.id,
      });
    }
  });

  return result;
};
